import React, { useState, useContext } from "react";
import instagram from "../../../icons/Instagram.png";
import AvatarModal from "./modals/expertModal/avatarModal";
import { CustomModal } from "../../../components/CustomModal";
import NameModal from "./modals/expertModal/nameModal";
import ContactModal from "./modals/expertModal/contactModal";
import icon1 from "../../../icons/call.png";
import telegram from "../../../icons/Telegram.png";
import whatsApp from "../../../icons/WhatsApp.png";
import email from "../../../icons/Gmail.png";
import linkDin from "../../../icons/Linkedin.png";
import icon2 from "../../../icons/Logo call.png";
import tak from "../../../icons/tak.png";
import { useMutation } from "@tanstack/react-query";
import { updateExpert } from "../../../service/api";
import ExpertDataContext from "../../../context/expertDataContext";
import { useQueryClient } from "@tanstack/react-query";
import FileKeysContext from "../../../context/fileKeysContext";
import { Skeleton } from "antd";

import "react-loading-skeleton/dist/skeleton.css";
import UploadingProcessContext from "../../../context/uploadingProcessContext";
function Expert({ data, isLoading }) {
  const queryClient = useQueryClient();
  const { expertData, resetExpertDataContext } = useContext(ExpertDataContext);
  const { expertAvatarKey, resetFileKeysContext } = useContext(FileKeysContext);
  const { resetUploadingProcessContext } = useContext(UploadingProcessContext);
const[loading,setLoading]=useState()
  const [showAvatarModal, setShowAvatarModal] = useState(false);
  const [showNameModal, setShowNameModal] = useState(false);
  const [showContactsModal, setShowContactsModal] = useState(false);
  const [showContactsMiniModal, setShowContactsMiniModal] = useState(false);
 
  const avatar = data?.avatar;
  const name = data?.firstName + " " + data?.lastName;
  const degreeId = data?.academicDegree?.id;
  const degree = data?.academicDegree?.name;
  const field = data?.academicField?.name;
  const phoneNumber = data?.phoneNumber;
  const symbolId = data?.symbolId;
  const conections = {
    landingNumber: data?.landingNumber,
    phoneNumber: data?.phoneNumber,
    takId: data?.takId,
    whatsApp: data?.whatsappPhoneNumber,
    telegramId: data?.telegramId,
    linkDin: data?.linkedInURL,
    email: data?.email,
    instagram: data?.instagramId,
    showPhoneNumber: data?.phoneNumberIsPublic,
  };
  let w = document.documentElement.clientWidth || window.innerWidth;

  const contactsModalHandler = () => {
    resetExpertDataContext();
    if (w > 640) {
      setShowContactsModal(true);
    } else if (w <= 640) {
      setShowContactsMiniModal(true);
    }
  };

  const avatarModalHandler = () => {
    setShowAvatarModal(true);
    resetFileKeysContext();
    resetUploadingProcessContext();
  };

  const mutation = useMutation(updateExpert, {
    onMutate:()=>{
setLoading(true)
    },
    onError:()=>{
 
      setLoading(false)
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["expertData"]);
      setShowNameModal(false);
      setShowAvatarModal(false);
      setShowContactsModal(false);
      setShowContactsMiniModal(false);
      setLoading(false)
    },
  });

  const onNameModalOk = () => {
    mutation.mutate(expertData);
  };

  const onAvatarModalOk = () => {
    if(expertAvatarKey === '') {
    } else {
      mutation.mutate({ avatar: expertAvatarKey });
    }
  };

  const onContactModalOk = () => {
    mutation.mutate(expertData);
  };
  return (
    <div className="font-body flex max-lg:flex-col justify-between mt-[-7.8rem] max-lg:mt-[-5.3rem] max-lg:gap-2 ">
      {/* right section */}
      <section className="flex font-body items-end ">
        {/* avatar and expert or experienced tag */}
        <div
          onClick={avatarModalHandler}
        
          className="flex flex-col ml-[-8.1rem] z-50 relative max-lg:pr-3 hover:cursor-pointer hover:brightness-90 "
        
        >
     
          <img
     
            className="w-32 h-32 rounded-2xl mb-[-0.5rem] max-lg:w-[5.625rem] max-lg:h-[5.625rem] bg-white"
            alt="avatar"
            src={
              avatar?.startsWith("http")
                ? avatar
                : process.env.REACT_APP_ARVAN_S3_BASE_URL + avatar
            }
          />
          <label
            hidden={symbolId === 4 ? true : false}
            className=" max-lg:text-xs max-lg:w-[3.6875rem] max-lg:px-2 text-xl z-30 font-bold bg-[#005AC8] rounded-xl text-white py-1 w-[6rem] m-auto"
          >
            متخصص
          </label>
          <label
            hidden={symbolId === 4 ? false : true}
            className=" max-lg:text-xs max-lg:w-[3.6875rem] max-lg:px-2 text-xl z-30 font-bold bg-[#008f45] rounded-xl text-white py-1 w-[6rem] m-auto"
          >
            خبره
          </label>
        </div>

        {/* name and academic data */}
        <div
        
          onClick={() => setShowNameModal(true)}
         
          className="relative"
        >
       
          <div
        
            className="flex flex-col bg-white py-[0.3rem] pr-[9rem] pl-[1rem]  h-fit rounded-2xl text-right relative max-lg:hidden hover:brightness-90 hover:cursor-pointer "
          >
            <div className="flex flex-row gap-1">
              <p hidden={degreeId === 1 ? false : true}>دکتر</p>

              <p className="w-full">
                {isLoading ? <Skeleton loading={isLoading} active /> : name}
              </p>
            </div>
            <p className="text-[#009538] text-xs font-bold w-full">
              {isLoading ? <Skeleton loading={isLoading} active /> : degree}{" "}
              {isLoading ? <Skeleton loading={isLoading} active /> : field}
            </p>
          </div>
        </div>
      </section>

      {/* left section */}
      <section className="flex flex-row items-end gap-2 max-lg:flex-col max-lg:items-center">
        {data?.phoneNumberIsPublic && (
          <div className="flex flex-col text-[#009538] max-lg:gap-2 font-bold  max-lg:justify-center max-lg:flex-row max-lg:w-full">
            <p>ارتباط با کارشناس:</p>
            <p>{phoneNumber}</p>
          </div>
        )}
        <div
         
        
          className="relative"
          onClick={contactsModalHandler}
        >
   
          <div
       
            className="flex flex-row items-end justify-end gap-1 hover:brightness-90 hover:cursor-pointer "
          >
            <img className="w-8 h-8" alt="insta" src={instagram} />
            <img className="w-8 h-8" alt="insta" src={icon1} />
            <img className="w-8 h-8" alt="insta" src={icon2} />
            <img className="w-8 h-8" alt="insta" src={telegram} />
            <img className="w-8 h-8" alt="insta" src={tak} />
            <img className="w-8 h-8" alt="insta" src={whatsApp} />
            <img className="w-8 h-8" alt="insta" src={linkDin} />
            <img className="w-8 h-8" alt="insta" src={email} />
          </div>
        </div>
      </section>

      {/* avatar modal */}
      {showAvatarModal && (
        <CustomModal
        loading={loading}
          onOk={onAvatarModalOk}
          handleCancel={() => setShowAvatarModal(false)}
          visible={showAvatarModal}
        >
          <AvatarModal />
        </CustomModal>
      )}

      {/* name modal */}
      {showNameModal && (
        <CustomModal
        loading={loading}
          onOk={onNameModalOk}
          visible={showNameModal}
          handleCancel={() => setShowNameModal(false)}
        >
          <NameModal modalData={data} size={200} />
        </CustomModal>
      )}

      {/* contacts modal responsive*/}
      <CustomModal
       loading={loading}
        onOk={onContactModalOk}
        size={"44vw"}
        visible={showContactsModal}
        handleCancel={() => setShowContactsModal(false)}
      >
        <ContactModal conections={conections} />
      </CustomModal>

      {/* contact modal desktop */}
      <CustomModal
       loading={loading}
        onOk={onContactModalOk}
        size={"100vw"}
        visible={showContactsMiniModal}
        handleCancel={() => setShowContactsMiniModal(false)}
      >
        <ContactModal conections={conections} />
      </CustomModal>
    </div>
  );
}

export default Expert;
